import Phaser from 'phaser';
import { GAME_HEIGHT, GAME_WIDTH, GROUND_Y, WORLD_WIDTH } from '../config/game';

export function addSky(scene: Phaser.Scene, world = false): void {
  const width = world ? WORLD_WIDTH : GAME_WIDTH;
  scene.add.image(width / 2, GAME_HEIGHT / 2, 'sky').setDisplaySize(width, GAME_HEIGHT).setScrollFactor(world ? 1 : 0).setDepth(-20);
  if (world) {
    // 16:9 raster art is displayed at its native aspect ratio: 1500 / 844 ≈ 16 / 9.
    scene.add.image(width / 2, GAME_HEIGHT / 2, 'pixel-hills-sky').setDisplaySize(width, GAME_HEIGHT).setScrollFactor(0.24).setDepth(-19);
    return;
  }
  for (let x = 60; x < width; x += 260) scene.add.image(x, 140 + (x % 3) * 25, 'licensed-cloud').setDisplaySize(120, 56).setScrollFactor(0.18).setDepth(-17);
  for (let x = 0; x < width + 150; x += 250) scene.add.image(x + 115, GROUND_Y - 90, 'hill').setDisplaySize(240, 155).setOrigin(0.5, 1).setScrollFactor(0.42).setDepth(-15);
}

export function addGround(scene: Phaser.Scene): Phaser.GameObjects.Rectangle {
  // Keep drawing and physics separate. Tiny source sprites can otherwise create
  // small gaps between Arcade bodies, causing the actor to fall through.
  for (let x = 16; x < WORLD_WIDTH; x += 32) {
    scene.add.image(x, GROUND_Y + 16, 'ground').setDisplaySize(32, 32).setDepth(2);
    scene.add.image(x, GROUND_Y + 48, 'ground').setDisplaySize(32, 32).setDepth(1);
  }
  const collider = scene.add.rectangle(WORLD_WIDTH / 2, GROUND_Y + 24, WORLD_WIDTH, 48, 0x000000, 0);
  scene.physics.add.existing(collider, true);
  return collider;
}

export function addMuteButton(scene: Phaser.Scene, onToggle: () => boolean): void {
  const label = scene.add.text(GAME_WIDTH - 22, 28, 'SOUND: AN', { fontFamily: 'PixelFallback, monospace', fontSize: '10px', color: '#ffffff', backgroundColor: '#172142' }).setOrigin(1, 0.5).setPadding(6, 4, 6, 4).setScrollFactor(0).setDepth(100);
  label.setInteractive({ useHandCursor: true }).on('pointerdown', () => label.setText(onToggle() ? 'SOUND: AUS' : 'SOUND: AN'));
}
